import { Reducer } from 'redux';
import { produce } from 'immer';

import { STATUS_OBJ } from 'utils/statusEnum';
import { CLAIMS_TYPES, ClaimsState, IClaim, StatusAction } from './types';

export const INITIAL_STATE: ClaimsState = {
  status: [],
  states: [],
  active: {
    hasMore: false,
    results: [],
    responseValid: true,
  },
  completed: {
    hasMore: false,
    results: [],
    responseValid: true,
  },
  drafts: {
    results: [],
    responseValid: true,
  },
  searchClaims: [],

  claimById: {} as IClaim,

  statusActions: {} as StatusAction,

  hasDraftModalOpen: false,

  stepsClaimStatus: [],
  timelineClaimId: '',

  trfRem: [],
};

const reducer: Reducer<ClaimsState> = (
  state = INITIAL_STATE,
  action = { type: '', payload: {} },
) => {
  return produce(state, draft => {
    switch (action.type) {
      case CLAIMS_TYPES.GET_CLAIMS_ACTIVE:
        draft.active.results = action.payload.results;
        draft.active.hasMore = action.payload.hasMore;
        draft.active.responseValid = true;
        break;
      case CLAIMS_TYPES.GET_CLAIMS_COMPLETED:
        draft.completed.results = action.payload.results;
        draft.completed.hasMore = action.payload.hasMore;
        draft.active.responseValid = true;
        break;
      case CLAIMS_TYPES.INVALID_ACTIVE_CLAIMS_RESPONSE:
        draft.active.responseValid = false;
        draft.drafts.responseValid = false;
        break;
      case `${CLAIMS_TYPES.SET_CLAIMS_BY_STATUS}_${STATUS_OBJ.Draft}`:
        draft.drafts.results = action.payload;
        draft.drafts.responseValid = true;
        break;
      case CLAIMS_TYPES.SET_SEARCH_CLAIMS:
        draft.searchClaims = action.payload;
        break;
      case CLAIMS_TYPES.GET_STATUS:
        draft.status = action.payload;
        break;
      case CLAIMS_TYPES.GET_STATES:
        draft.states = action.payload;
        break;
      case CLAIMS_TYPES.SET_STEPS_BY_CLAIM_ID:
        draft.stepsClaimStatus = action.payload;
        break;
      case CLAIMS_TYPES.SET_CLAIM_BY_ID:
        draft.claimById = action.payload;
        break;
      case CLAIMS_TYPES.SET_STATUS_ACTIONS:
        draft.statusActions = action.payload;
        break;
      case CLAIMS_TYPES.TOGGLE_OPEN_MODAL:
        draft.hasDraftModalOpen = action.payload;
        break;
      case CLAIMS_TYPES.CLEAN_CLAIMS:
        draft.active = INITIAL_STATE.active;
        draft.completed = INITIAL_STATE.completed;
        draft.drafts = INITIAL_STATE.drafts;
        draft.hasDraftModalOpen = INITIAL_STATE.hasDraftModalOpen;
        break;
      case CLAIMS_TYPES.CLEAN_TIMELINE:
        draft.stepsClaimStatus = [];
        draft.claimById = {} as IClaim;
        draft.timelineClaimId = '';
        break;

      case CLAIMS_TYPES.SET_TIMELINE_CLAIM_ID:
        draft.timelineClaimId = action.payload;
        break;

      case CLAIMS_TYPES.SET_TRF_REM_BY_CLAIM_ID:
        draft.trfRem = action.payload;
        break;
      default:
    }
  });
};

export default reducer;
